let environment = process.env.REACT_APP_ENV || 'development';

export default environment
